// rfc
// https://www.youtube.com/watch?v=LFVMs_jmhNU

import "./App.css";

import React from "react";
import { BrowserRouter as Router } from "react-router-dom";
import { useState, useEffect } from "react";

import AuthApi from "./Route/AuthApi";
import Routes from "./Route/Routes";
import Cookies from "js-cookie";

import Header from "./components/Header";
import Footer from "./components/Footer";
import Menu from "./components/Menu";
// import Content from "./components/Content";

// import Login from "./components/Login";
// import LockScreen from "./components/LockScreen";
// import Home from "./components/Home";
// import Page404 from "./components/Page404";

export default function App() {
  const [auth, setAuth] = useState(false);

  const readCookies = () => {
    const user = Cookies.get("JurniHRLogin");
    if (user) {
      setAuth(true);
    }
  };
  useEffect(() => {
    readCookies();
  }, []);

  return (
    <div  style={{height:'100vh'}}>
    <AuthApi.Provider value={{ auth, setAuth }}>
      <Router>
        <Routes />
      </Router>
    </AuthApi.Provider>
    </div>
    // <React.Fragment>
    //   <Menu />
    //   <Header />
    //   <Footer />
    // </React.Fragment>
  );
}
